<template>
  <div class="c-counsel c-standard">
    <h3 class='title_h3 relative'>
      <span>{{ text.title }}</span>
      <div class="textBgCenter absolute" style='top: -50%'></div>
    </h3>
    <div style='margin-top:20px'>
      <div class="c-counsel__items">
        <div class="c-counsel__item" v-for="(item, index) in counsel" v-show="(counselPage * 6 - 6) <= index && (counselPage * 6 - 1) >= index" @click="routeTo('information', item.id )" :key="index">
          <div class="c-counsel__item--img">
            <img :src="item.image" alt="item.title">
          </div>
          <div class="c-counsel__item--content">
            <h4 v-if="languageDefault == 'en_us'">{{item.title_en}}</h4>
            <h4 v-else-if="languageDefault == 'de_de'">{{item.title_de}}</h4>
            <h4 v-else>{{item.title}}</h4>
            <p v-if="languageDefault == 'en_us'">{{item.content_en}}</p>
            <p v-else-if="languageDefault == 'de_de'">{{item.content_de}}</p>
            <p v-else>{{item.content}}</p>
          </div>
        </div>
      </div>
      <div class="c-counsel__pagination" v-if="getCounselPage(counsel.length) > 1">
        <q-pagination v-model="counselPage" icon-prev="fa fa-angle-left" icon-next="fa fa-angle-right" color="blue-9" :max="getCounselPage(counsel.length)" :direction-links="true"></q-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'counselBlock',
    // props: ['contact'],
    components: {
      'q-pagination': Quasar.QPagination,
    },
    data(){
      return{
        text:{
          title: this.$t('counsel_block.title')
        },
        counsel:[
          {
            title:'为学院实训室安装电动橱柜和升降台',
            title_en: "Installation of a Pressalit Kitchen desk and cupboard system",
            title_de: "Einrichtung einer barrierefreien Küche",
            image: require('../../assets/img/20200922_changzhou_shengjiangtai.jpg'),
            content: '2020-09-22',
            content_en: 'Sep 22, 2020',
            content_de: '22. Sept. 2020',
            id: 0
          },
          {
            title:'参展第十六届 CHINA AID 博览会',
            title_en: "Our Booth on the 16th China Aid trade fair in Shanghai",
            title_de: "Unser Stand auf der 16ten China Aid Messe in Shanghai",
            image: require('../../assets/img/20201030_shanghai_chinaaid.jpg'),
            content: '2020-10-30',
            content_en: 'Oct 30, 2020',
            content_de: '30. Okt. 2020',
            id: 1
          },
        ],
        counselPage: 1,
        languageDefault: localStorage.getItem('lang') || 'zh_cn'
      }
    },
    computed: {
      getCounselPage: function() {
        return function(page){
          if (!page) {
            return 1
          }
          return Math.ceil(page / 6)
        }
      },
    },
    methods:{
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
    created(){

    }
  }
</script>

<style>


</style>
